import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Fourfiveseaterbusonrentinpune() {



  const cardData =
  {
    keyword: '45 Seater Bus On Rent in Pune ',
    heading: 'Sanavi Travels: 45 Seater Bus On Rent in Pune',
    headingDescription: 'Sanavi Travels offers reliable 45 Seater Bus On Rent in Pune, providing safe, comfortable, and hassle-free group transportation for corporate teams, schools and colleges, tour groups, wedding guests, religious trips, and large events. Our well-maintained 45 seater buses are ideal for long-distance travel, corporate outings, educational tours, and mass group movements, featuring spacious seating, air-conditioned interiors, ample luggage space, and smooth ride comfort. With experienced and licensed chauffeurs, flexible one-way and round-trip rental options, transparent pricing, and 24/7 booking support, Sanavi Travels ensures a smooth, punctual, and enjoyable travel experience. From doorstep pickup across Pune—including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, and Pune Airport—to drop-off at destinations such as Lonavala, Mahabaleshwar, Shirdi, Nashik, Mumbai, and other outstation routes, Sanavi Travels provides trusted 45 Seater Bus rental services in Pune for customers seeking comfort, safety, and dependable large-group transportation.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


 "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort and a symbol of Maratha glory. Once the seat of Bajirao I’s administration, it features massive stone walls, grand gateways like the Delhi Darwaza, and lush lawns. Although much of it was destroyed in a fire, the remnants still echo royal grandeur. The evening light-and-sound show vividly brings Maratha history to life. Shaniwar Wada stands as Pune’s proud emblem of heritage, valor, and architectural brilliance."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum showcasing Gandhi’s personal artifacts, photographs, and historical documents. The palace’s sprawling gardens, Italian arches, and serene ambiance make it a peaceful retreat. The site also houses the samadhis of Kasturba Gandhi and Mahadev Desai, making it a symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations with music, decorations, and cultural events. The trust behind the temple is also known for extensive charitable work. Devotees find immense peace, blessings, and spiritual solace here. Dagdusheth Ganpati remains the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive up to explore its ancient ramparts, memorials, and scenic viewpoints. The fort offers breathtaking views of the Sahyadri ranges, dotted with lush greenery. Local vendors serve traditional pithla-bhakri meals near the summit. Sinhagad is Pune’s favorite blend of history, adventure, and nature, attracting both historians and thrill-seekers."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. It features monolithic pillars, a circular Nandi pavilion, and a serene sanctum. Despite being located in a busy urban area, it maintains a tranquil spiritual ambiance. Its ancient carvings showcase the mastery of early Indian craftsmanship. Pataleshwar is Pune’s hidden heritage retreat, offering peace, meditation, and a connection with the city’s ancient past."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. The collection includes traditional ornaments, musical instruments, household antiques, and sculptures. The recreated Mastani Mahal is a major attraction, depicting the lifestyle of historical India. The museum serves as a living archive of art, craftsmanship, and history, making it an invaluable destination for art lovers, students, and tourists seeking cultural insights."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add to its cultural charm. Sunrise and sunset visits are especially mesmerizing. Parvati Hill is Pune’s spiritual and scenic high point, attracting devotees, history enthusiasts, and nature lovers alike."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across beautifully landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation, rejuvenation, and personal transformation. Osho Ashram is Pune’s international retreat for tranquility, blending spiritual learning with holistic wellness practices."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers. Families, joggers, and photography enthusiasts enjoy peaceful walks here. The garden beautifully blends Japanese aesthetics with Indian nature, offering a serene sanctuary within Pune’s urban landscape. It is an ideal spot for relaxation, picnics, and reconnecting with nature."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The vast waterscape and surrounding hills create a picturesque setting, especially during the monsoon season. Street vendors selling roasted corn, tea, and local snacks add to its charm. The dam also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy escape for weekends, sunset views, and family outings, offering both natural beauty and recreational opportunities."
  }
]
,





"services": [
    {
      "name": "45 Seater Bus On Rent in Pune",
      "description": "45 Seater Bus On Rent in Pune provides spacious and comfortable buses for large group travel within Pune and surrounding areas. Ideal for family trips, corporate outings, weddings, sightseeing tours, and events, these buses feature ample seating, luggage compartments, and modern amenities. Professional drivers ensure safe, punctual, and smooth journeys. Flexible rental options and transparent pricing make this service convenient for day trips or long-distance travel."
    },
    {
      "name": "45 Seater Bus Hire Pune",
      "description": "45 Seater Bus Hire Pune offers flexible rental services for day trips, outstation journeys, and special events. Well-maintained buses accommodate large groups comfortably. Experienced chauffeurs handle traffic and routes efficiently, ensuring timely arrivals and a hassle-free journey. Perfect for corporate events, school trips, family vacations, or group tours, providing convenience, safety, and comfort."
    },
    {
      "name": "AC 45 Seater Bus Pune",
      "description": "AC 45 Seater Bus Pune provides air-conditioned buses for a cool and comfortable travel experience. Ideal for long-distance trips, corporate travel, family outings, and sightseeing tours, these buses offer spacious seating and luggage-friendly interiors. Professional drivers ensure optimized routes, safety, and smooth travel, allowing passengers to relax and enjoy the journey."
    },
    {
      "name": "Luxury Bus Rental Pune",
      "description": "Luxury Bus Rental Pune offers premium 45 seater buses with well-appointed interiors, reclining seats, entertainment systems, and ample luggage space. Perfect for VIP trips, corporate travel, weddings, and group tours, these buses ensure a stylish, comfortable, and stress-free journey. Experienced chauffeurs provide safe, timely, and professional service for all travel needs."
    },
    {
      "name": "45 Seater Bus for Wedding Pune",
      "description": "45 Seater Bus for Wedding Pune provides reliable transportation for wedding guests, ensuring comfort, space, and safety. Ideal for pre-wedding functions, ceremonies, and group transfers, these buses feature spacious seating, luggage-friendly interiors, and professional drivers. Passengers experience smooth, timely, and hassle-free travel for all wedding events."
    },
    {
      "name": "Corporate 45 Seater Bus Hire Pune",
      "description": "Corporate 45 Seater Bus Hire Pune caters to office groups, business travelers, and corporate events. Buses offer premium seating, work-friendly amenities, and ample luggage space. Professional chauffeurs maintain punctuality and safe driving, allowing employees or executives to work or rest during the journey. Ideal for corporate trips, conferences, team outings, or client transfers."
    },
    {
      "name": "Outstation 45 Seater Bus Pune",
      "description": "Outstation 45 Seater Bus Pune provides dependable and comfortable buses for long-distance travel. Suitable for weekend getaways, sightseeing trips, corporate tours, and group excursions, these buses feature spacious seating, luggage-friendly interiors, and experienced drivers. Safety, comfort, and punctuality are prioritized for smooth outstation travel."
    },
    {
      "name": "Affordable 45 Seater Bus Pune",
      "description": "Affordable 45 Seater Bus Pune offers budget-friendly rental options for large groups without compromising comfort or safety. Well-maintained buses with ample seating and luggage space, driven by professional drivers, ensure a stress-free journey. Perfect for family trips, friends, corporate groups, or event transport, combining affordability with reliability."
    },
    {
      "name": "Chauffeur Driven 45 Seater Bus",
      "description": "Chauffeur Driven 45 Seater Bus provides experienced drivers for safe and hassle-free travel. Passengers can relax while the driver handles traffic, highways, and long-distance routes. Spacious interiors and luggage-friendly compartments ensure comfort for all passengers, making this service ideal for families, friends, corporate groups, and event travel."
    },
    {
      "name": "Group Travel 45 Seater Bus Pune",
      "description": "Group Travel 45 Seater Bus Pune is designed for large groups such as families, friends, corporate teams, or school trips. Buses are spacious, comfortable, and equipped for long journeys. Experienced drivers manage routes efficiently, ensuring timely arrivals and smooth travel. Perfect for sightseeing, corporate outings, weddings, or leisure trips."
    },
    {
      "name": "Best 45 Seater Bus Pune",
      "description": "Best 45 Seater Bus Pune offers top-quality buses and professional service for a superior travel experience. Comfortable interiors, skilled drivers, and attention to passenger convenience make journeys safe, smooth, and enjoyable. Suitable for corporate groups, families, friends, or event transport, emphasizing reliability, punctuality, and comfort."
    },
    {
      "name": "Pune Bus Booking Service",
      "description": "Pune Bus Booking Service allows easy online and offline booking for 45 seater buses. Flexible scheduling, transparent pricing, and well-maintained buses ensure convenient and comfortable travel. Suitable for corporate trips, family outings, weddings, sightseeing tours, or group events."
    },
    {
      "name": "Tourist Bus Rental Pune",
      "description": "Tourist Bus Rental Pune provides reliable transport for sightseeing trips, leisure travel, and group tours. Spacious seating, luggage-friendly interiors, and professional drivers ensure a comfortable and enjoyable journey. Perfect for tourists exploring Pune and surrounding areas, combining convenience, safety, and smooth travel."
    },
    {
      "name": "Event Bus Hire Pune",
      "description": "Event Bus Hire Pune offers dependable buses for transporting guests to weddings, corporate events, parties, and special occasions. Spacious seating, luggage-friendly compartments, and professional drivers ensure safe, punctual, and comfortable travel. Ideal for large groups attending events in and around Pune."
    },
    {
      "name": "Family Trip Bus Pune",
      "description": "Family Trip Bus Pune provides safe, spacious, and comfortable transport for families traveling together. Ideal for long-distance trips, vacations, sightseeing tours, and weekend getaways, these buses ensure ample seating, luggage space, and professional drivers. Passengers enjoy stress-free and convenient travel experiences."
    }
  ],
  "tableData": [
    ["45 Seater Bus On Rent in Pune", "45 Seater Bus Hire Pune"],
    ["AC 45 Seater Bus Pune", "Luxury Bus Rental Pune"],
    ["45 Seater Bus for Wedding Pune", "Corporate 45 Seater Bus Hire Pune"],
    ["Outstation 45 Seater Bus Pune", "Affordable 45 Seater Bus Pune"],
    ["Chauffeur Driven 45 Seater Bus", "Group Travel 45 Seater Bus Pune"],
    ["Best 45 Seater Bus Pune", "Pune Bus Booking Service"],
    ["Tourist Bus Rental Pune", "Event Bus Hire Pune"],
    ["Family Trip Bus Pune", "—"]
  ]
,


"whychoose": [
  {
    "WhyChooseheading": "45 Seater Bus On Rent in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable 45-seater bus rental services in Pune, ideal for large group tours, corporate trips, school/college outings, and long-distance travel with comfort and safety."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable 45-Seater Buses",
    "WhyChoosedescription": "Travel in air-conditioned, well-maintained 45-seater buses offering ample legroom and comfort for all passengers."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Pune Routes",
    "WhyChoosedescription": "Our professional drivers are familiar with Pune city, highways, and surrounding areas, ensuring safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear, upfront pricing for 45-seater bus rentals, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, route planning, and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from half-day, full-day, or customized rental plans to meet your group’s travel requirements in Pune."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All 45-seater buses are thoroughly cleaned and sanitized before every trip to ensure passenger safety and hygiene."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for 45-seater bus rentals in Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide 45-seater bus on rent in Pune?',
    answer: 'Yes, Sanavi Travels offers well-maintained and comfortable 45-seater buses for large group travel in Pune.'
  },
  {
    question: 'How can I book a 45-seater bus in Pune with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What seating capacity does the 45-seater bus offer?',
    answer: 'The bus comfortably accommodates 45 passengers, suitable for large groups and long-distance travel.'
  },
  {
    question: 'Are drivers included in the 45-seater bus rental?',
    answer: 'Yes, all rentals include experienced and professional drivers.'
  },
  {
    question: 'Is the 45-seater bus rental service available 24x7?',
    answer: 'Yes, our service is available round the clock for bookings and travel.'
  },
  {
    question: 'Are the vehicles sanitized before trips?',
    answer: 'Yes, all 45-seater buses are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I customize the 45-seater bus rental plan?',
    answer: 'Absolutely. Sanavi Travels offers customized rental plans according to your group’s travel needs.'
  },
  {
    question: 'What payment options are available for 45-seater bus bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vijay Kulkarni',
    feedback: 'Booked a 45-seater bus from Sanavi Travels. Spacious, comfortable, and professional service for our large group in Pune.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Anusha Deshmukh',
    feedback: 'Excellent experience! Clean bus, on-time pickup, and courteous driver made our Pune journey smooth and enjoyable.',
    rating: 5
  }
];






























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "45 Seater Bus On Rent in Pune - Sanavi Travels",
  "description": "45 Seater bus on rent in Pune by Sanavi Travels for weddings, corporate travel, outstation trips, family tours, events, and group journeys. Choose AC and luxury 45 seater buses for comfortable and affordable travel in Pune and nearby areas.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2130"
  }
};




  return (
    <div>

<Helmet>
  <title>
    45 Seater Bus On Rent in Pune Starting from ₹55 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book 45 Seater bus on rent in Pune with Sanavi Travels. AC and luxury 45 seater bus for weddings, corporate travel, outstation trips, family tours, events, and group travel at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>
      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/16.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Fourfiveseaterbusonrentinpune;